// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loader_loading__2w9a-"};